import * as React from "react";
import { Modal, Button } from "antd";
import { TTranslate } from "../../../service/locale/TranslationService";
export interface State {}

export interface Props {
  applicantAssignationDialogVisible?: boolean;
  hideApplicantAssignationDialog: any;
  translate: TTranslate;
  rowData: any;
  assignApplicantsToReportingPeriod: any;
}

export default class ApplicantAssignationDialog extends React.Component<
  Props,
  State
> {
  render() {
    const {
      translate,
      rowData,
      applicantAssignationDialogVisible,
      hideApplicantAssignationDialog,
      assignApplicantsToReportingPeriod
    } = this.props;

    return (
      <div>
        <Modal
          title={translate("reporting_periods.assign_applicant_modal_title")}
          visible={applicantAssignationDialogVisible}
          onCancel={hideApplicantAssignationDialog}
          maskClosable={false}
          footer={[
            <Button key="back" onClick={hideApplicantAssignationDialog}>
              {translate("modal_functions.assign_modal.cancel")}
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={e => {
                assignApplicantsToReportingPeriod(rowData);
                hideApplicantAssignationDialog();
              }}
            >
              {translate(
                "modal_functions.assign_modal.assign"
              )}
            </Button>
          ]}
        >
          <span>
            {translate("reporting_periods.messages.assign_applicant_message")}
          </span>
        </Modal>
      </div>
    );
  }
}
